import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-upload', 'upload', 'Upload');
Labels.set('ui-upload', 'uploadFiles', 'Upload files');
Labels.set('ui-upload', 'clear', 'Remove file');
